module.exports = __webpack_public_path__ + "img/how-to_image07.2f852792.png";